import React from "react";
import classNames from "classnames/bind";
import styles from "../../AddJobModal.module.scss";
import { SearchIcon } from "~/assets/icons";

const cx = classNames.bind(styles);

interface ContactSearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const ContactSearchBox: React.FC<ContactSearchBoxProps> = ({
  value,
  onChange,
  placeholder = "Search by name, email, address or phone...",
}) => {
  return (
    <div className={cx("existing-contact-section")}>
      <h4 className={cx("title")}>Search Contacts</h4>
      <div className={cx("search-box")}>
        <input
          type="text"
          placeholder={placeholder}
          className={cx("input")}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <SearchIcon className={`${cx("search-icon")} w-[20px] h-[20px]`} />
      </div>
    </div>
  );
};

export default ContactSearchBox;
